'use client';

import React__default from 'react';
import { Container } from './BadgeTag.css.js';
import PremiumIcon from './Images/PremiumIcon.js';
import UrgentIcon from './Images/UrgentIcon.js';
import TopManageIcon from './Images/TopManageIcon.js';
import HotIcon from './Images/HotIcon.js';
import HeadHunterIcon from './Images/HeadHunterIcon.js';
import { ELanguage } from '../Utils/constants.js';
import translation from './translation.js';
import MatchingIcon from './Images/MatchingIcon.js';

var BadgeTag = function (props) {
    var type = props.type, langCode = props.langCode, utm = props.utm;
    var name = type;
    var Icon;
    var url = '';
    var t = function (key) {
        if (langCode === ELanguage.VI) {
            return translation[key] || key;
        }
        else {
            return key;
        }
    };
    switch (type) {
        case 'Hot':
            Icon = HotIcon;
            break;
        case 'Premium':
            Icon = PremiumIcon;
            break;
        case 'Top management':
            Icon = TopManageIcon;
            url = t('/management-jobs') + utm;
            break;
        case 'Urgent':
            Icon = UrgentIcon;
            break;
        case 'Head hunter':
            Icon = HeadHunterIcon;
            break;
        case 'New':
            name = t(type);
            break;
        case 'Matching':
            Icon = MatchingIcon;
            name = t(type);
            break;
    }
    return url ? (React__default.createElement("a", { href: url, title: name },
        React__default.createElement(Container, { type: type },
            Icon && React__default.createElement(Icon, null),
            " ",
            name))) : (React__default.createElement(Container, { type: type, title: name },
        Icon && React__default.createElement(Icon, null),
        " ",
        name));
};

export { BadgeTag as default };
//# sourceMappingURL=index.js.map
